import { render, staticRenderFns } from "./fileButton.vue?vue&type=template&id=0eed97ec"
import script from "./fileButton.vue?vue&type=script&lang=js"
export * from "./fileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports